import React from "react";
import { SWATCHES } from "../lib/site";
import Reveal from "./Reveal";
import { WhatsAppButton } from "./WhatsApp";

export default function Prints() {
  return (
    <section id="prints" className="bg-[var(--bone)] py-24 md:py-36">
      <div className="max-w-[1100px] mx-auto px-6 sm:px-10 lg:px-14 text-center">
        <Reveal>
          <h2 className="serif text-[42px] sm:text-[56px] md:text-[64px] leading-[1.05] text-[#111] font-light">
            The Fabric Palette.
          </h2>
        </Reveal>

        <Reveal delay={120}>
          <p className="sans text-[16px] leading-[1.85] text-[#111]/90 max-w-[640px] mx-auto mt-6">
            Limited edition prints. Since we only produce three dresses per print,
            our availability changes weekly. Message us to see today's curated
            selection.
          </p>
        </Reveal>

        {/* Swatches */}
        <Reveal delay={220}>
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 sm:gap-12">
            {SWATCHES.map((s, i) => (
              <div
                key={s.name}
                className="flex flex-col items-center gap-4"
                data-testid={`swatch-${s.name.toLowerCase()}`}
              >
                <div
                  className="swatch w-24 h-24 sm:w-28 sm:h-28 rounded-full ring-1 ring-[#111]/8 shadow-sm bg-cover overflow-hidden"
                  style={
                    s.image
                      ? {
                          backgroundImage: `url(${s.image})`,
                          backgroundSize: "cover",
                          backgroundPosition: s.position || "center",
                        }
                      : { ...s.style, backgroundSize: "cover" }
                  }
                  aria-label={`${s.name} fabric swatch`}
                />
                <span className="serif italic text-[17px] text-[#111]/95">{s.name}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={320}>
          <div className="mt-16 flex flex-col items-center gap-4">
            <WhatsAppButton testId="prints-cta" variant="dark">
              Chat with us for the full brochure & prints
            </WhatsAppButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
